import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.3.3@antd/es/col/index.js
// module id = null
// module chunks = 